export default class Dropdown {
	constructor(element) {
		this.$el = element
		this.$triggerBtn = this.$el.querySelector('[data-toggle="dropdown"]')
		this.$innerContent = this.$el.querySelector('.base-dropdown__inner')
		this.init();
	}
	init() {
		const {$triggerBtn, $innerContent} = this
		$triggerBtn.addEventListener('click', () => {
			$triggerBtn.classList.toggle("active")
			$innerContent.classList.toggle("hidden")
		})
		document.addEventListener('click', (e) => {
			const target = e.target;

			const its_menu = target === $innerContent || $innerContent.contains(target);
			const its_btnMenu = target === $triggerBtn;
			const menu_is_active = !$innerContent.classList.contains('hidden');

			if (!its_menu && !its_btnMenu && menu_is_active) {
				$triggerBtn.classList.toggle("active");
				$innerContent.classList.toggle("hidden");
			}
		});
	}
}
